import { PATH, SECTIONS_ID } from "../../../../constants/navigation";
import { TEL_SEGRETERIA } from "../../../../constants/contacts";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import Button from "../../../../components/ui/button/button";
import { Fade, Zoom } from "react-awesome-reveal";

import "./about-contact-us.scss";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

const AboutContactUs = () => {
  const device = useBreakpoint();
  const isMoblie = device === "mobile";
  return (
    <section className="about-contact-us">
      <Fade direction="up" duration={900} triggerOnce>
        <IntroSectionBadge
          title={"Scopri Come Possiamo Aiutarti"}
          text={
            "Con oltre 20 anni di esperienza e tecnologie brevettate, siamo pronti a supportare il tuo prossimo progetto."
          }
          bgColor={"light"}
        />
      </Fade>
      <Zoom
        duration={700}
        delay={200}
        cascade
        triggerOnce
        style={{ width: "100%" }}
      >
        <div className="about-contact-us__buttons">
          <Button
            text={"Contattaci"}
            type="primary"
            iconName={"phone"}
            fullWidth={isMoblie}
            fitContent={!isMoblie}
            href={TEL_SEGRETERIA}
          />
          <Button
            text={"Vedi i Nostri Servizi"}
            type="secondary"
            iconName={"eye"}
            fullWidth={isMoblie}
            fitContent={!isMoblie}
            to={`${PATH.home}#${SECTIONS_ID.home.services}`}
          />
        </div>
      </Zoom>
    </section>
  );
};

export default AboutContactUs;
